import { DailyStock } from "@/api/daily-stock-api";
import { ProductVariant, VariantStockSearchItem } from "@/types/product-type";
import { getAuthUser } from "./auth-utils";

/**
 * Converts a VariantStockSearchItem (from tree view) to a ProductVariant (for form editing)
 */
export function convertVariantSearchItemToProductVariant(item: VariantStockSearchItem): ProductVariant {
    const user = getAuthUser();
    // Construct a partial DailyStock object from the flat fields
    const stock: DailyStock = {
        id: "0", // Placeholder as we don't have the stock ID directly
        storeId: user?.store?.id || "1", // Default store ID todo
        productId: item.productId,
        variantId: item.id.toString(),
        stockDate: new Date().toISOString(),
        openQty: item.openQty,
        stockInHand: item.stockInHand,
        soldQty: item.soldQty,
        receiveQty: item.receiveQty,
        adjustInQty: item.adjustInQty,
        adjustOutQty: item.adjustOutQty,
        closingQty: item.closingQty,
        locked: false,
    };

    return {
        id: item.id.toString(),
        productId: item.productId,
        storeId: parseInt(user?.store?.id || "1"), // Default store ID todo
        sku: item.sku,
        name: item.variantName,
        variantKey: item.variantKey || "default",
        price: item.price,
        cost: 0, // Default cost as it's not in the search item
        imageUrl: item.imageUrl,
        pinned: item.pinned,
        productName: item.productName,
        stock: stock,
        isActive: true,
        // Fill required BaseModelFields
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
    };
}
